export const CSV_REPORTS_TAGS = {
  TEAM_USERS_CSV: "TeamUsersCsv",
} as const;
